<template>
  <div class="container-list">
    <div class="flex">
      <unitList v-show="!($store.state.user.userInfo.natureId == 2)" @select="getUnit" @getFirst="getOne"></unitList>

      <div class="flex1">
        <div class="common-page common-tool-bar">
          <el-row :gutter="10" class="mb8">
            <el-col :span="1.5">
              <el-button type="primary" icon="el-icon-plus" @click="handleAdd" v-hasPermi="['trmoni:fireFacilitiesManage:add']">新增</el-button>
            </el-col>
            <!--      <el-col :span="1.5">-->
            <!--        <el-button-->
            <!--          type="success"-->
            <!--          icon="el-icon-edit"-->
            <!--          size="mini"-->
            <!--          :disabled="single"-->
            <!--          @click="handleUpdate"-->
            <!--          v-hasPermi="['trmoni:fireFacilitiesManage:edit']"-->
            <!--        >修改</el-button>-->
            <!--      </el-col>-->
            <!-- <el-col :span="1.5">
        <el-button
          type="danger"
          icon="el-icon-delete"
          :disabled="multiple"
          @click="handleDelete"
          v-hasPermi="['trmoni:fireFacilitiesManage:remove']"
        >删除</el-button>
      </el-col> -->
            <!-- <el-col :span="1.5">
        <el-button
          type="warning"
          icon="el-icon-download"
          @click="handleExport"
          v-hasPermi="['trmoni:fireFacilitiesManage:export']"
        >导出</el-button>
      </el-col> -->
            <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
          </el-row>
        </div>
        <el-table v-loading="loading" :data="manageList" @selection-change="handleSelectionChange" :row-class-name="rowColor">
          <!-- <el-table-column type="selection" width="55" align="center" /> -->
          <el-table-column label="主键" align="center" prop="id" v-if="false" />
          <!--      <el-table-column label="用户userid" align="center" prop="userId" />-->
          <!--      <el-table-column label="公司编号" align="center" prop="companyId" />-->
          <!--      <el-table-column label="消防设施编号id" align="center" prop="fireFacilitiesSettingsId" />-->
          <el-table-column label="设施名称" align="center" prop="fireFacilitiesName" />
          <el-table-column label="使用区域" align="center" prop="userArea" />
          <el-table-column label="数量" align="center" prop="num" />
          <el-table-column label="第1次应维修时间" align="center" prop="firstShouldMaintenanceTime">
            <template slot-scope="scope">
              <span>{{ parseTime(scope.row.firstShouldMaintenanceTime, "{y}-{m}-{d}") }}</span>
            </template>
          </el-table-column>
          <el-table-column label="第2次应维修时间" align="center" prop="secondShouldMaintenanceTime">
            <template slot-scope="scope">
              <span>{{ parseTime(scope.row.secondShouldMaintenanceTime, "{y}-{m}-{d}") }}</span>
            </template>
          </el-table-column>
          <el-table-column label="第3次应维修时间" align="center" prop="thirdShouldMaintenanceTime">
            <template slot-scope="scope">
              <span>{{ parseTime(scope.row.thirdShouldMaintenanceTime, "{y}-{m}-{d}") }}</span>
            </template>
          </el-table-column>
          <el-table-column label="第4次应维修时间" align="center" prop="fourthShouldMaintenanceTime">
            <template slot-scope="scope">
              <span>{{ parseTime(scope.row.fourthShouldMaintenanceTime, "{y}-{m}-{d}") }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="第1次实际维修时间" align="center" prop="firstMaintenanceTime" width="180">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.firstMaintenanceTime, '{y}-{m}-{d}') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="第2次实际维修时间" align="center" prop="secondMaintenanceTime" width="180">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.secondMaintenanceTime, '{y}-{m}-{d}') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="第3次实际维修时间" align="center" prop="thirdMaintenanceTime" width="180">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.thirdMaintenanceTime, '{y}-{m}-{d}') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="第4次实际维修时间" align="center" prop="fourthMaintenanceTime" width="180">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.fourthMaintenanceTime, '{y}-{m}-{d}') }}</span>
        </template>
      </el-table-column> -->
          <el-table-column label="起始时间" align="center" prop="startDate">
            <template slot-scope="scope">
              <span>{{ parseTime(scope.row.startDate, "{y}-{m}-{d}") }}</span>
            </template>
          </el-table-column>
          <el-table-column label="到期时间" align="center" prop="expireDate">
            <template slot-scope="scope">
              <span>{{ parseTime(scope.row.expireDate, "{y}-{m}-{d}") }}</span>
            </template>
          </el-table-column>
          <el-table-column label="使用年限" align="center" prop="usePeriod" />
          <el-table-column label="状态" align="center" prop="status">
            <template scope="scope">
              <span v-if="scope.row.status == '1'"><el-tag>待维修</el-tag></span>
              <span v-if="scope.row.status == '2'"><el-tag type="warning">待停用</el-tag></span>
              <span v-if="scope.row.status == '3'"><el-tag type="success">正常使用</el-tag></span>
              <span v-if="scope.row.status == '4'"><el-tag type="danger">已停用</el-tag></span>
            </template>
          </el-table-column>
          <!-- <el-table-column
        label="用户选定状态: 1:使用中  0:已停用"
        align="center"
        prop="selectStatus"
      /> -->
          <el-table-column label="操作" align="center" class-name="small-padding">
            <template slot-scope="scope">
              <el-button size="mini" type="warning" @click="handleUpdate(scope.row)" v-hasPermi="['trmoni:fireFacilitiesManage:edit']">修改</el-button>
              <el-button size="mini" type="danger" @click="handleDelete(scope.row)" v-hasPermi="['trmoni:fireFacilitiesManage:remove']">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="getList" />
      </div>
    </div>
    <el-dialog title="查询" :visible.sync="showSearch" :close-on-click-modal="false">
      <el-form :model="queryParams" ref="queryForm" :inline="true" v-show="showSearch" label-width="120px">
        <el-form-item label="设施名称" prop="fireFacilitiesName">
          <el-input v-model="queryParams.fireFacilitiesName" placeholder="请输入设施名称" clearable size="small" @keyup.enter.native="handleQuery" />
        </el-form-item>
        <el-form-item label="使用区域" prop="userArea">
          <el-input v-model="queryParams.userArea" placeholder="请输入使用区域" clearable size="small" @keyup.enter.native="handleQuery" />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="queryParams.status" placeholder="请选择状态" clearable size="small">
            <el-option label="正常使用" :value="3" />
            <el-option label="待维修" :value="1" />
            <el-option label="待停用" :value="2" />
            <el-option label="已停用" :value="4" />
          </el-select>
        </el-form-item>
        <div class="dialog-footer center">
          <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </div>
      </el-form>
    </el-dialog>

    <!-- 添加或修改消防设施管理对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="90%" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="150px">
        <!-- <el-form-item label="消防设施编号id" prop="fireFacilitiesSettingsId">
          <el-input v-model="form.fireFacilitiesSettingsId" placeholder="请输入消防设施编号id" />
        </el-form-item> -->
        <el-row>
          <el-col :span="8">
            <el-form-item v-if="addType" label="设施名称" class="" prop="fireFacilitiesName">
              <div class="flex">
                <el-input v-model="form.fireFacilitiesName" placeholder="请输入设施名称" />
                <el-button class="ml20" @click="changeType(0)">自定义</el-button>
              </div>
            </el-form-item>
            <el-form-item v-else label="设施名称" prop="fireFacilitiesSettingsId">
              <div class="flex">
                <!-- <el-input v-model="form.fireFacilitiesSettingsId" placeholder="请输入消防设施编号id" /> -->
                <el-select v-model="form.fireFacilitiesSettingsId" @change="selectItem">
                  <el-option v-for="(item, index) in fireDevice" :label="item.name" :value="item.id" :key="index"> </el-option>
                </el-select>
                <el-button class="ml20" @click="changeType(1)">自定义</el-button>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="使用区域" prop="userArea">
              <el-input v-model="form.userArea" placeholder="请输入使用区域" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="数量" prop="num">
              <el-input v-model="form.num" type="number" placeholder="请输入数量" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="起始时间" prop="startDate">
              <el-date-picker
                clearable
                size="small"
                v-model="form.startDate"
                type="date"
                @change="addStartTime"
                value-format="yyyy-MM-dd"
                placeholder="选择起始时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="使用年限" prop="usePeriod">
              <el-input :disabled="!addType" type="number" v-model="form.usePeriod" @blur="addStartTime" placeholder="请输入使用年限" />
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="到期时间" prop="expireDate">
              <el-date-picker clearable size="small" v-model="form.expireDate" type="date" value-format="yyyy-MM-dd" placeholder="选择到期时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="8">
            <el-form-item label="状态">
              <!-- <el-input
                v-model="form.selectStatus"
                placeholder="请输入状态"
              /> -->
              <el-select v-model="form.selectStatus">
                <el-option label="使用中" :value="1">使用中</el-option>
                <el-option label="已停用" :value="0">已停用</el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- <el-form-item label="快到期提醒时间" prop="reminderTime">
          <el-input
            v-model="form.reminderTime"
            placeholder="请输入快到期提醒时间"
          />
        </el-form-item> -->
        <div v-if="!addType">
          <el-row>
            <el-col :span="8" v-if="selectItems && selectItems.firstMaintenanceTime !== null">
              <el-form-item label="第1次应维修时间" prop="firstShouldMaintenanceTime">
                <el-date-picker
                  clearable
                  size="small"
                  v-model="form.firstShouldMaintenanceTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  disabled
                  placeholder="选择第1次应维修时间"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="第1次实际维修时间" prop="firstMaintenanceTime">
                <el-date-picker
                  clearable
                  size="small"
                  v-model="form.firstMaintenanceTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择第1次实际维修时间"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="8" v-if="selectItems && selectItems.secondMaintenanceTime !== null">
              <el-form-item label="第2次应维修时间" prop="secondShouldMaintenanceTime">
                <el-date-picker
                  clearable
                  size="small"
                  v-model="form.secondShouldMaintenanceTime"
                  type="date"
                  disabled
                  value-format="yyyy-MM-dd"
                  placeholder="选择第2次应维修时间"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="第2次实际维修时间" prop="secondMaintenanceTime">
                <el-date-picker
                  clearable
                  size="small"
                  v-model="form.secondMaintenanceTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择第2次实际维修时间"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="selectItems && selectItems.thirdMaintenanceTime !== null">
              <el-form-item label="第3次应维修时间" prop="thirdShouldMaintenanceTime">
                <el-date-picker
                  clearable
                  size="small"
                  v-model="form.thirdShouldMaintenanceTime"
                  type="date"
                  disabled
                  value-format="yyyy-MM-dd"
                  placeholder="选择第3次应维修时间"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="第3次实际维修时间" prop="thirdMaintenanceTime">
                <el-date-picker
                  clearable
                  size="small"
                  v-model="form.thirdMaintenanceTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择第3次实际维修时间"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" v-if="selectItems && selectItems.fourthMaintenanceTime !== null">
              <el-form-item label="第4次应维修时间" prop="fourthShouldMaintenanceTime">
                <el-date-picker
                  clearable
                  size="small"
                  v-model="form.fourthShouldMaintenanceTime"
                  type="date"
                  disabled
                  value-format="yyyy-MM-dd"
                  placeholder="选择第4次应维修时间"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="第4次实际维修时间" prop="fourthMaintenanceTime">
                <el-date-picker
                  clearable
                  size="small"
                  v-model="form.fourthMaintenanceTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择第4次实际维修时间"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- <el-form-item label="状态 1:待维修、2:待停用、3:正常使用、4:已停用">
        
          <el-select v-model="form.status"> 
              <el-option label="待维修" value="1"></el-option>
              <el-option label="待停用、3" value="2"></el-option>
              <el-option label="正常使用、4" value="3"></el-option>
              <el-option label="已停用" value="4"></el-option>


          </el-select>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  listFireFacilitiesManage,
  getFireFacilitiesManage,
  delFireFacilitiesManage,
  addFireFacilitiesManage,
  updateFireFacilitiesManage,
  exportFireFacilitiesManage,
} from "@/api/trmonitor/fireFacilitiesManage";
import { dateAddYear } from "../../utils/tool";
import unitList from "@/components/unitList";

export default {
  name: "Manage",
  components: { unitList },

  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      selectItems: null, // 选中得的设施
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: false,
      cpNum: "",
      // 总条数
      total: 0,
      // 消防设施管理表格数据
      manageList: [],
      fireDevice: [], // 消防设施列表
      addType: false, // 自定义
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        userId: null,
        companyId: null,
        fireFacilitiesSettingsId: null,
        fireFacilitiesName: null,
        userArea: null,
        num: null,
        firstShouldMaintenanceTime: null,
        secondShouldMaintenanceTime: null,
        thirdShouldMaintenanceTime: null,
        fourthShouldMaintenanceTime: null,
        firstMaintenanceTime: null,
        secondMaintenanceTime: null,
        thirdMaintenanceTime: null,
        fourthMaintenanceTime: null,
        startDate: null,
        expireDate: null,
        usePeriod: null,
        companyNum: "",
        status: null,
        reminderTime: null,
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {},
    };
  },
  watch: {
    cpNum() {
      this.queryParams.companyNum = this.cpNum;
      this.queryParams.pageNum = 1;

      this.getList();
    },
    addType(val) {
      if (val) {
        this.form.fireFacilitiesSettingsId = "";
      } else {
        this.form.fireFacilitiesName = "";
      }
    },
  },
  created() {
    this.$get("/trmoni/fireFacilities/listAll").then((res) => {
      console.log(res);
      this.fireDevice = res.data;
    });
    console.log(dateAddYear);
    // this.getList();
  },
  methods: {
    rowColor({ row, rowIndex }) {
      if (row.status == 1 || row.status == 2) {
        return "red";
      }
      return "";
    },
    getOne(v) {
      this.cpNum = v;
    },
    getUnit(v) {
      this.cpNum = v;
    },
    addStartTime(e) {
      console.log(e);
      if (this.form.startDate && this.form.usePeriod) {
        console.log(this.selectItems);
        this.form.expireDate = dateAddYear(this.form.startDate, this.form.usePeriod);
        if (!this.addType) {
          this.form.firstShouldMaintenanceTime = this.selectItems.firstMaintenanceTime
            ? dateAddYear(this.form.startDate, String(this.selectItems.firstMaintenanceTime))
            : "";

          this.form.secondShouldMaintenanceTime = this.selectItems.secondMaintenanceTime
            ? dateAddYear(this.form.startDate, String(this.selectItems.firstMaintenanceTime + this.selectItems.secondMaintenanceTime))
            : "";
          this.form.thirdShouldMaintenanceTime = this.selectItems.thirdMaintenanceTime
            ? dateAddYear(
                this.form.startDate,
                String(this.selectItems.firstMaintenanceTime + this.selectItems.secondMaintenanceTime + this.selectItems.thirdMaintenanceTime),
              )
            : "";
          this.form.fourthShouldMaintenanceTime = this.selectItems.fourthMaintenanceTime
            ? dateAddYear(
                this.form.startDate,
                String(
                  this.selectItems.firstMaintenanceTime +
                    this.selectItems.secondMaintenanceTime +
                    this.selectItems.thirdMaintenanceTime +
                    this.selectItems.fourthMaintenanceTime,
                ),
              )
            : "";
        }
      }
      console.log(this.form);
      // console.log()
    },
    selectItem(e, f) {
      if (!f) {
        this.reset();
      }
      if (this.addType) {
        this.form.fireFacilitiesName = e;
      } else {
        this.form.fireFacilitiesSettingsId = e;
      }
      this.fireDevice.map((it) => {
        if (it.id == e) {
          this.selectItems = it;
          this.form.usePeriod = it.usePeriod;
        }
      });
    },

    changeType(t) {
      this.reset();
      this.addType = t;
    },
    /** 查询消防设施管理列表 */
    getList() {
      this.loading = true;
      listFireFacilitiesManage(this.queryParams).then((response) => {
        this.manageList = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        userId: null,
        companyId: null,
        fireFacilitiesSettingsId: null,
        fireFacilitiesName: null,
        userArea: null,
        num: null,
        firstShouldMaintenanceTime: null,
        secondShouldMaintenanceTime: null,
        thirdShouldMaintenanceTime: null,
        fourthShouldMaintenanceTime: null,
        firstMaintenanceTime: null,
        secondMaintenanceTime: null,
        thirdMaintenanceTime: null,
        fourthMaintenanceTime: null,
        startDate: null,
        expireDate: null,
        usePeriod: null,
        status: 3,
        createTime: null,
        updateTime: null,
        delFlag: null,
        selectStatus: 1,
      };

      this.resetForm("form");
      this.addType = false;
      this.selectItems = {};
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map((item) => item.id);
      this.single = selection.length !== 1;
      this.multiple = !selection.length;
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加消防设施管理";
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const id = row.id || this.ids;
      getFireFacilitiesManage(id).then((response) => {
        this.form = response.data;
        this.form.selectStatus = Number(this.form.selectStatus);
        if (this.form.flag == 1) {
          this.addType = false;
          this.form.fireFacilitiesSettingsId = Number(this.form.fireFacilitiesSettingsId);
          this.selectItem(this.form.fireFacilitiesSettingsId, 1);
        } else {
          this.addType = true;
        }

        this.open = true;
        this.title = "修改消防设施管理";
      });
    },
    /** 提交按钮 */
    submitForm() {
      console.log(this.selectItems);
      this.form.reminderTime = this.selectItems ? this.selectItems.reminderTime || "1" : "1";
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.form.id != null) {
            updateFireFacilitiesManage(this.form).then((response) => {
              // this.$message.success("修改成功");
              this.$message({ 
										message: "修改成功", 
										type: "success", 
										duration: 700,});
              this.open = false;
              this.getList();
            });
          } else {
            addFireFacilitiesManage(this.form).then((response) => {
              // this.$message.success("新增成功");
              this.$message({ 
										message: "新增成功", 
										type: "success", 
										duration: 700,});
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const id = row.id;
      this.$confirm('是否确认删除消防设施管理编号为"' + id + '"的数据项?', "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function() {
          return delFireFacilitiesManage(id);
        })
        .then(() => {
          this.getList();
          this.msgSuccess("删除成功");
        });
    },
    /** 导出按钮操作 */
    handleExport() {
      const queryParams = this.queryParams;
      this.$confirm("是否确认导出所有消防设施管理数据项?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function() {
          return exportFireFacilitiesManage(queryParams);
        })
        .then((response) => {
          this.download(response.msg);
        });
    },
  },
};
</script>
